import $ from "jquery";

// describe and create object
class MobileScroll {
  constructor() {
    // this.mobile_scroll = $(".hamburger__button");
    this.headerNaviToggle = $("#header-navi-toggle");
    // Variablen, um die Scroll-Position zu speichern
    this.scrollPosition = { y: 0 };
    this.initialViewportHeight;
    this.intervalId;

    this.events();
  }

  events() {
    this.headerNaviToggle.on("change", (event) => this.toggleNavigation(event));
    // this.mobile_scroll.on("click", (e) => this.addClass(e));
  }

  // Method to handle checkbox toggle
  toggleNavigation(event) {
    if (event.target.checked) {
      this.onChecked();
    } else {
      this.onUnchecked();
    }
  }

  onChecked() {
    this.initialViewportHeight = window.innerHeight;
    this.scrollPosition.y = window.scrollY;
    console.log("Current viewport height:", this.initialViewportHeight);
    console.log("Scroll position saved:", this.scrollPosition.y);

    $("html").toggleClass("nav-scroll");
    $(window).scrollTop(0);
  }
  onUnchecked() {
    $("html").toggleClass("nav-scroll");
    this.intervalId = setInterval((e) => this.scrolltoPosition(e), 50);
  }

  scrolltoPosition(e) {
    let currentViewportHeight = window.innerHeight;
    console.log("Current scroll position:", window.scrollY);
    console.log("Current viewport height:", currentViewportHeight);

    // Check if the viewport height is the same as the initial height
    if (currentViewportHeight === this.initialViewportHeight) {
      // Scroll down to the target position if the heights match
      window.scrollTo(0, this.scrollPosition.y);
      console.log(this.scrollPosition.y);

      // Stop checking after scrolling to target
      clearInterval(this.intervalId);
    }
  }
}

export default MobileScroll;
